// extracted by mini-css-extract-plugin
export default {"page":"RequestDemoPage_page__iM7FR","inner":"RequestDemoPage_inner__+996D","title":"RequestDemoPage_title__cKHL3","subtitle":"RequestDemoPage_subtitle__eWVKF"};